import { render } from "./RenameLabelModal.vue?vue&type=template&id=05340d94"
import script from "./RenameLabelModal.vue?vue&type=script&lang=js"
export * from "./RenameLabelModal.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__